import React, { FunctionComponent as FC } from 'react';
import './index.scss';
import { Link } from 'react-router-dom';

interface MyPanelProps {
  viewTitle: string;
  width: string;
  height: string;
  panelHeaderHeight: number;
  // x?: number;
  // y?: number;
  children: React.ReactNode; // 👈️ added type for children
}

// const panelStyle = {
//   // titleDivWidth:
// }

const MyPanel: FC<MyPanelProps> = (props) => {

  const {
    viewTitle,
    width,
    height,
    panelHeaderHeight,
  } = props

  if (viewTitle === '') {
    return (
      <div className='panel' style={{width: width, height: height}}>
        <div className='panel-header' style={{height: panelHeaderHeight}}>
          <div className='left-align'>
            {/* <span className='line'>{viewTitle}</span> */}
          </div>
        </div>
        <div className='panel-body'>
          {props.children}
        </div>
      </div>
    )
  }
  if (viewTitle === 'DATA-DRIVEN ART') {
    return (
      <div className='panel' style={{width: width, height: height}}>
        <div className='panel-header data-art-title' style={{height: panelHeaderHeight, justifyContent: 'space-between'}}>
          <div className='left-align'>
            <span className='line'>{viewTitle}</span>
          </div>
          <div className='read-more'>
            <Link to="/dataArtPage">
              <span>READ MORE ▶</span>
            </Link>
            {/* <Link to="/dataArtPage" onClick={(e) => {
              e.preventDefault();
              window.location.href = '/dataArtPage';
            }}>
              <span>READ MORE ▶</span>
            </Link> */}
          </div>
        </div>
        <div className='panel-body'>
          {props.children}
        </div>
      </div>
    )
  }
  return (
    <div className='panel' style={{width: width, height: height}}>
      <div className='panel-header' style={{height: panelHeaderHeight}}>
        <div className='left-align'>
          {/* <span className="panel-title">{viewTitle}</span> */}
          {/* <span className="dot">.</span> */}
          <span className='line'>{viewTitle}</span>
        </div>
        {/* <div className='line'></div> */}
      </div>
      <div className='panel-body'>
      {/* style={{height: height - panelHeaderHeight}} */}
        {props.children}
      </div>
    </div>
  )
}

export default MyPanel